
// You can write more code here

/* START OF COMPILED CODE */

import EditorPlatformMarkerImage from "../../../EditorPlatformMarkerImage";
/* START-USER-IMPORTS */
/* END-USER-IMPORTS */

export default class PlatformMarkerFoliage2 extends EditorPlatformMarkerImage {

  constructor(scene: Phaser.Scene, x?: number, y?: number, texture?: string, frame?: number | string) {
    super(scene, x ?? 119.5, y ?? 36.5, texture || 'game-all', frame ?? "foliage-02.png");

    /* START-USER-CTR-CODE */
    // Write your code here.
    /* END-USER-CTR-CODE */
  }

  /* START-USER-CODE */

  // Write your code here.

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
